import type {
  OfferSortField,
  OfferSortParams,
  SortDirection,
} from '#shared/types/goliath/goliath.types';

export type UrlFilters = 'brandSlugs' | 'colorSlugs' | 'compatibleProductFamilySlugs';

export interface FilterConfig {
  positions: UrlFilters[];
  placeholders: Record<UrlFilters, string>;
  prefixes: Partial<Record<UrlFilters, string>>;
}

export type QueryFilters = {
  discounted?: string;
  maxPrice?: string;
  minPrice?: string;
  pageSize?: string;
  productProviders?: string[];
  productTagSlugs?: string[];
  anyInGroupOfProductTagSlugs?: string[][] | string[] | string;
  search?: string;
  sort?: string;
  fields?: string[] | string;
  filters?: string[] | string;
  notFilters?: string[] | string;
  orFilters?: string[] | string;
};

export interface Config {
  separators: {
    path: string;
    item: string;
    filter: string;
  };
  prefixes: {
    filter: string;
    page: string;
  };
  pathPrefix: string | null;
  filter: FilterConfig;
  sortMap: {
    [key: string]: OfferSortParams;
  };
  defaultSort: string;
  defaultPageSize: number;
}

const config: Config = {
  separators: {
    path: '/',
    item: '+',
    filter: '_',
  },
  prefixes: {
    filter: '_',
    page: 'seite-',
  },
  pathPrefix: null,
  filter: {
    positions: ['brandSlugs', 'colorSlugs', 'compatibleProductFamilySlugs'],
    placeholders: {
      brandSlugs: 'alle-hersteller',
      colorSlugs: 'alle-farben',
      compatibleProductFamilySlugs: 'alle-geraete',
    },
    prefixes: {
      compatibleProductFamilySlugs: 'fuer-',
    },
  },
  sortMap: {
    recommendation: {
      field: 'RECOMMENDATION' as OfferSortField.Recommendation,
      direction: 'ASC' as SortDirection.Asc,
    },
    relevance: {
      field: 'RELEVANCE' as OfferSortField.Relevance,
      direction: 'ASC' as SortDirection.Asc,
    },
    priceAsc: {
      field: 'ONETIME_PRICE' as OfferSortField.OnetimePrice,
      direction: 'ASC' as SortDirection.Asc,
    },
    priceDesc: {
      field: 'ONETIME_PRICE' as OfferSortField.OnetimePrice,
      direction: 'DESC' as SortDirection.Desc,
    },
    new: {
      field: 'INSERTED_AT' as OfferSortField.InsertedAt,
      direction: 'DESC' as SortDirection.Desc,
    },
  },
  defaultSort: 'recommendation',
  defaultPageSize: 48,
};

export default config;
